/**
 * Mobilní aplikace zaměstnanců (Capacitor) — co se v ní chová jinak než na webu.
 *
 * Aplikace spouští stejné `app.jsx` jako web; rozdíl nastaví startovací modul
 * `aplikace/start.jsx` do `window.__FL_APLIKACE` ještě před jeho importem.
 * Na webu je objekt prázdný a všechno tady vrací webové chování.
 */

export const jeAplikace = () => !!window.__FL_APLIKACE;

// Aplikace je Cockpit zaměstnance, ne celé OS. Moduly pro správu zůstávají
// na webu — odkaz nebo notifikace, která na ně vede, skončí na „bez přístupu".
const STRANKY_APLIKACE = new Set([
    'prehled',
    'aktivita',
    'zpravy',
    'znalosti',
    'znalosti-seznam',
    'moje-skoleni-detail',
    'report-smeny',
    'rozvoz-cockpit',
]);

export const smiVAplikaci = (page) => !jeAplikace() || STRANKY_APLIKACE.has(page);

// WebSocket (Reverb) — aplikace ho dostává ze serveru při startu, web z buildu.
export const reverbKonfigurace = () => {
    const ze = window.__FL_APLIKACE?.reverb;
    return {
        key: ze?.key ?? import.meta.env.VITE_REVERB_APP_KEY,
        host: ze?.host ?? import.meta.env.VITE_REVERB_HOST,
        port: ze?.port ?? import.meta.env.VITE_REVERB_PORT,
        scheme: ze?.scheme ?? import.meta.env.VITE_REVERB_SCHEME ?? 'https',
    };
};
